__turbopack_context__.v({
  "actions": "ParagraphCtaBanner-module__tht2DW__actions",
  "author": "ParagraphCtaBanner-module__tht2DW__author",
  "authorLine": "ParagraphCtaBanner-module__tht2DW__authorLine",
  "authorName": "ParagraphCtaBanner-module__tht2DW__authorName",
  "authorPhone": "ParagraphCtaBanner-module__tht2DW__authorPhone",
  "authorRole": "ParagraphCtaBanner-module__tht2DW__authorRole",
  "banner": "ParagraphCtaBanner-module__tht2DW__banner",
  "bg": "ParagraphCtaBanner-module__tht2DW__bg",
  "btn": "ParagraphCtaBanner-module__tht2DW__btn",
  "desc": "ParagraphCtaBanner-module__tht2DW__desc",
  "eyebrow": "ParagraphCtaBanner-module__tht2DW__eyebrow",
  "eyebrowMark": "ParagraphCtaBanner-module__tht2DW__eyebrowMark",
  "inner": "ParagraphCtaBanner-module__tht2DW__inner",
  "title": "ParagraphCtaBanner-module__tht2DW__title",
});
